import React from 'react';
import {
  Typography,
  Button,
  TextField,
  Grid,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import withShipment from "../../withShipment";
import { userInfoSelector, usersSelector } from "../../redux/selectors/auth";
import { getUsers } from "../../redux/actions/auth";

import "./Todo.css";
import CustomToolbar from "../global/CustomToolbar";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import TwoStepDelete from "../global/subcomponents/twoStepDelete/TwoStepDelete";
import Card from "@material-ui/core/Card";
import axios from "axios";
import {BASE_URL} from "../global/Server/endpoints";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import EditNoteIcon from '@mui/icons-material/EditNote';
import {Autocomplete} from "@material-ui/lab";

class Todo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      todos: [],
      newTodo: { title: '', description: '', deadline: new Date(), assignedTo: '', companyId: this.props.userInfo.companyId },
      openDialog: false,
      commentInputs: {},
      editingTodo: null,

      // feedback bar states
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
      addingCommentFor: null
    };
  }

  componentDidMount() {
    this.props.getUsers();
    this.fetchTodos();
  }

  /* ---------------- Feedback Bar ------------------- */

  openFeedbackBar = (status,message) => {
    this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
  }

   closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
    })
  }

  /* ------------------ API Calls -------------------- */

  fetchTodos = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/todo/list`,
        { companyId: this.props.userInfo.companyId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      this.setState({ todos: res.data.todos || [] });
    } catch (e) {
      this.openFeedbackBar("error", "Failed to load tasks");
    }
  };

  createTodo = async () => {
    const { newTodo, editingTodo } = this.state;
    const token = localStorage.getItem("token");

    if (!newTodo.title || !newTodo.assignedTo) {
      this.openFeedbackBar("error", "Title and Assigned User are required");
      return;
    }

    try {
      const url = editingTodo ? `${BASE_URL}/todo/update` : `${BASE_URL}/todo/save`;
      const payload = editingTodo ? { ...newTodo, todoId: editingTodo.todoId } : newTodo;

      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
      });

      if (res.data.success) {
        this.openFeedbackBar("success", res.data.message);
        this.fetchTodos();
      } else {
        this.openFeedbackBar("error", res.data.message);
      }
    } catch (e) {
      this.openFeedbackBar("error", e.response?.data?.message || "Error saving task");
    }
  };

  updateStatus = async (todoId, newStatus) => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/todo/updateStatus`,
        {todoId: todoId, status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      this.openFeedbackBar("success", res.data.message);
      this.fetchTodos();
    } catch (e) {
      this.openFeedbackBar("error", "Failed to change status");
    }
  };

  deleteTodo = async (todoId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${BASE_URL}/todo/delete`,
        { todoId: todoId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      this.openFeedbackBar("success", res.data.message);
      this.fetchTodos();
    } catch (e) {
      this.openFeedbackBar("error", "Failed to delete task");
    }
  };

  addComment = async (todoId) => {
    const token = localStorage.getItem("token");
    const comment = this.state.commentInputs[todoId];

    if (!comment) return;

    try {
      const res = await axios.post(
        `${BASE_URL}/todo/addComment`,
        { todoId: todoId, comment: comment, userId: this.props.userInfo.userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      this.openFeedbackBar("success", res.data.message);
      this.setState(prev => ({
        commentInputs: { ...prev.commentInputs, [todoId]: '' }
      }));

      this.fetchTodos();
    } catch (e) {
      this.openFeedbackBar("error", "Failed adding comment");
    }
  };

  /* --------------------------------------------------*/

  handleInputChange = (field, value) => {
    this.setState(prev => ({
      newTodo: { ...prev.newTodo, [field]: value }
    }));
  };

  openDialog = (todo = null) => {
    if (todo) {
      this.setState({ editingTodo: todo, newTodo: { ...todo, deadline: new Date(todo.deadline) }, openDialog: true });
    } else {
      this.setState({ editingTodo: null, newTodo: { title: '', description: '', deadline: new Date(), assignedTo: '', companyId: this.props.userInfo.companyId }, openDialog: true });
    }
  };
  closeDialog = () => this.setState({ openDialog: false });

  render() {
    const { todos, newTodo } = this.state;
    const { allUsers, userInfo } = this.props;
    const isAdmin = (userInfo?.authority || []).includes("ROLE_ADMIN");

    const headerButtons = isAdmin ? [{ icon: <AddCircleIcon />, handler: this.openDialog, title: "Add Task" }] : [];

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>

          <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
        />

        <CustomToolbar title="Tasks" createTitle="Task" backTitle="Back To Menu" headerButtons={headerButtons} />

        {/* Create Task Modal */}
        <Dialog open={this.state.openDialog} onClose={this.closeDialog} fullWidth maxWidth="sm">
          <DialogTitle> {this.state.editingTodo ? "Update Task": "Create New Task"}</DialogTitle>

         <DialogContent>
          <TextField
            variant="outlined"
            label="Title"
            value={newTodo.title}
            onChange={e => this.handleInputChange('title', e.target.value)}
            fullWidth
            style={{ marginBottom: 16 }}
          />

          <Autocomplete
            options={allUsers.filter(user => !(user.authorities || []).some(auth => auth.authority === 'ROLE_ADMIN'))}
            getOptionLabel={option => [option.firstname, option.lastname].filter(Boolean).join(' ')}
            autoHighlight
            disableClearable
            value={allUsers.find(user => user.userId === newTodo.assignedTo) || null}
            onChange={(event, newValue) => this.handleInputChange('assignedTo', newValue?.userId || '')}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assign To"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                style={{ marginBottom: 16 }}
              />
            )}
          />

          <KeyboardDatePicker
            margin="normal"
            label="Deadline"
            format="MM/dd/yyyy"
            value={newTodo.deadline}
            onChange={date => this.handleInputChange('deadline', date)}
            fullWidth
            inputVariant="outlined"
          />

          <TextField
            variant="outlined"
            label="Description"
            value={newTodo.description}
            onChange={e => this.handleInputChange('description', e.target.value)}
            fullWidth
            multiline
            rows={3}
            style={{ marginTop: 16 }}
          />
        </DialogContent>

          <DialogActions>
            <Button onClick={this.closeDialog}>Cancel</Button>
            <Button color="primary" variant="contained" onClick={() => { this.createTodo(); this.closeDialog(); }}> {this.state.editingTodo ? "Update Task" : "Add Task"}</Button>
          </DialogActions>
        </Dialog>

        {/* Todo List */}
        {todos.map(todo => (
          <Card key={todo.id} className="todo-task" style={{ borderLeft: todo.status === 'Pending' ? '5px solid red' : '5px solid green' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">{todo.title}</Typography>
                <Typography variant="body2">{todo.description}</Typography>
                <Typography variant="caption" style={{ display: 'block', marginTop: 4 }}>
                  Task Created: {new Date(todo.createdAt).toLocaleDateString()}
                </Typography>
                <Typography variant="caption">Deadline: {new Date(todo.deadline).toLocaleDateString()}</Typography>
              </Grid>

              <Grid item xs={12} sm={3}>
                <label style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={todo.status === 'Completed'}
                    onChange={e => this.updateStatus(todo.todoId, e.target.checked ? 'Completed' : 'Pending')}
                  />
                  <span style={{ marginLeft: 8, fontWeight: 'bold' }}>{todo.status}</span>
                </label>
              </Grid>

              <Grid item xs={12} sm={3}>
                {isAdmin && (
                  <>
                    <EditNoteIcon
                      style={{ cursor: 'pointer',marginLeft:'20px' }}
                      onClick={() => this.openDialog(todo)}
                    />
                    <TwoStepDelete
                      rowId={todo.todoId}
                      handleDelete={this.deleteTodo}
                      deleteId={this.state.deleteId}
                      setDeleteId={(newId) => this.setState({ deleteId: newId })}
                    />
                  </>
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider style={{ marginBottom: 8 }} />
                <Typography variant="subtitle2" style={{marginBottom:'8px'}}>Comments:</Typography>

                {/* Existing comments */}
                {todo.comments?.map(c => {
                  const createdAt = c.createdAt?.$date ? new Date(c.createdAt.$date) : new Date(c.createdAt);

                  return (
                    <div
                      key={`${c.userId}-${createdAt.getTime()}`}
                      style={{
                        padding: '6px 12px',
                        marginBottom: 6,
                        backgroundColor: '#f9f9f9',
                        borderRadius: 8,
                        border: '1px solid #e0e0e0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <span style={{ flex: 1 }}>{c.comment}</span>
                      <span style={{ marginLeft: 12, fontStyle: 'italic', color: '#888', whiteSpace: 'nowrap' }}>
                        — {c.name}
                      </span>
                    </div>
                  );
                })}

                {/* Add comment section */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
                  {this.state.addingCommentFor === todo.todoId ? (
                    <>
                      <TextField
                        placeholder="Write a comment..."
                        fullWidth
                        size="small"
                        value={this.state.commentInputs[todo.todoId] || ""}
                        onChange={e => {
                          const value = e.target.value;
                          this.setState(prev => ({
                            commentInputs: { ...prev.commentInputs, [todo.todoId]: value }
                          }));
                        }}
                      />
                      <Button
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: 8 }}
                        onClick={() => {
                          this.addComment(todo.todoId);
                          this.setState({ addingCommentFor: null });
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        onClick={() => this.setState({ addingCommentFor: null })}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <AddCircleIcon
                      style={{ cursor: 'pointer', color: 'green',marginTop:'8px' }}
                      onClick={() => this.setState({ addingCommentFor: todo.todoId })}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </Card>
        ))}
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
  allUsers: usersSelector(state),
});

const actionCreators = {
  getUsers
};

export default withShipment({ mapStateToProps, actionCreators }, Todo);
